import PortalIdParser from 'PortalIdParser';
import enviro from 'enviro';
import { stringify } from 'hub-http/helpers/params';
import { getFullUrl } from 'hubspot-url-utils';
import { na1 } from 'hubspot-url-utils/hublets';
import { getPublicLocalizedPathname } from 'marketplace-ui-common/utils/urls';
import { Flow } from 'signup-constants/Flow';
import { SignupUrlGenerator } from 'signup-ui-url-generator/SignupUrlGenerator';
const isQa = () => enviro.isQa();
const getRootPath = () => '/marketplace';
export const getRootUrl = () => {
  return `/ecosystem/${PortalIdParser.get()}${getRootPath()}`;
};
export const getPublicRootUrl = lang => {
  return `${getPublicLocalizedPathname(lang)}${getRootPath()}`;
};
export const getDownloadedAssetsUrl = (isPublic = false, offeringType = 'THEME') => {
  if (isPublic) {
    return `${getFullUrl('app', {
      hubletOverride: na1
    })}/l/marketplace-settings/downloads/${offeringType === 'MODULE' ? 'modules' : 'theme'}`;
  }
  return `${getFullUrl('app')}/marketplace-settings/${PortalIdParser.get()}/downloads/${offeringType === 'MODULE' ? 'modules' : 'theme'}`;
};
export const getDownloadedAssetsSuccessUrl = (params, offeringType) => `${getDownloadedAssetsUrl(false, offeringType)}?${stringify(params)}`;
export const getDownloadedAssetsUpdateUrl = (offeringId, offeringType) => `${getDownloadedAssetsUrl(false, offeringType)}?updateOfferingId=${offeringId}`;
export const getCmsHubPricingUrl = (upgradeSource = 'marketplace-asset-installability') => `https://www.hubspot.com/pricing/content?upgradeSource=${upgradeSource}`;
export const getMarketingHubPricingUrl = (upgradeSource = 'marketplace-asset-installability') => `https://www.hubspot.com/pricing/marketing?upgradeSource=${upgradeSource}`;
const getCmsFreeSignupQuery = theme => {
  const query = {
    intent: 'marketplaceTheme'
  };
  if (theme) {
    query.theme = theme;
  }
  return query;
};
export const getCmsFreeSignupUrl = theme => {
  return new SignupUrlGenerator(Flow.CmsFree, {
    env: isQa() ? 'qa' : 'prod',
    query: getCmsFreeSignupQuery(theme)
  }).getUrl();
};
export const getCmsFreeLoginSignupParams = theme => {
  return JSON.stringify([Flow.CmsFree, {
    query: getCmsFreeSignupQuery(theme)
  }]);
};
export const getAppShortlink = ({
  pathname = '',
  query = {},
  theme
} = {}, includeSignupParams = true) => {
  const signupParams = getCmsFreeLoginSignupParams(theme);
  const params = stringify(Object.assign({}, query, {
    signupParams: includeSignupParams ? signupParams : undefined
  }));
  return `${getFullUrl('app', {
    hubletOverride: 'na1'
  })}/l/ecosystem/marketplace${pathname}${params ? `?${params}` : ''}`;
};